import { render, staticRenderFns } from "./FrameworkSubjectTable.vue?vue&type=template&id=456cb137"
import script from "./FrameworkSubjectTable.vue?vue&type=script&lang=js"
export * from "./FrameworkSubjectTable.vue?vue&type=script&lang=js"
import style0 from "./FrameworkSubjectTable.vue?vue&type=style&index=0&id=456cb137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
